import ThemeToggler from 'components/common/ThemeToggler';
import { useAppContext } from 'providers/AppProvider';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';
import React, { useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';

function NavbarAssessment() {
  const { setSettingsPanelConfig } = useSettingsPanelContext();
  const {
    config: { navbarTopAppearance },
    setConfig
  } = useAppContext();

  useEffect(() => {
    setConfig({ navbarTopShape: 'slim' });
    setSettingsPanelConfig({
      showSettingPanelButton: false
    });
  }, []);
  return (
    <Navbar
      className="navbar-top fixed-top navbar-slim"
      expand
      variant=""
      data-navbar-appearance={navbarTopAppearance === 'darker' ? 'darker' : ''}
    >
      <div className="navbar-collapse justify-content-between">
        <div className="navbar-logo">
          <Navbar.Brand className="me-1 me-sm-3">Crud Beat</Navbar.Brand>
        </div>
      </div>
      <Nav.Item>
        <ThemeToggler slim />
      </Nav.Item>
    </Navbar>
  );
}

export default NavbarAssessment;
